// 左側組織樹點設備 → 放進影像牆第一個空格（手機上不能拖，用點的）。影像牆不在畫面上時沒有人聽，點了只是切範圍。
const EV = 'kinio:place-camera';

export function placeCamera(key: string): void {
  window.dispatchEvent(new CustomEvent(EV, { detail: key }));
}

export function onPlaceCamera(fn: (key: string) => void): () => void {
  const h = (e: Event) => fn((e as CustomEvent<string>).detail);
  window.addEventListener(EV, h);
  return () => window.removeEventListener(EV, h);
}
